export default __webpack_public_path__ + "static/media/chat.270ac2fb.PNG";